<template>
  <section id="locations">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 text-center">
          <h2 class="text-xl" style="color: #777">
            Reserve cabanas at the most desirable hotels on
            <span class="text-xl" style="color:#26a1e0">South Beach.</span>
          </h2>
        </div>
        <!-- end .col-lg-12 -->
      </div>
      <!-- end .row -->

      <div class="search-container">
        <div class="row justify-content-md-center">
          <!-- class="col-lg-10" -->
          <div class="wrap-search-Section">
            <div class="search-wrapper">
              <div class="row">
                <!-- class="col-sm-6" -->
                <div class="for-padding-responsive">
                  <!-- <el-select
                   class="locations"
                    v-model="location"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="Enter hotel name"
                    :remote-method="remoteMethod"
                    :loading="loading">
                    <el-option
                      v-for="item in locationOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select> -->
                  <!--  :disabled="!location" -->

                  <span class="location-select-wrapper">
                    <el-select
                      class="locations"
                      v-model="location"
                      filterable
                      placeholder="Enter hotel name"
                      :loading="loading"
                    >
                      <el-option
                        v-for="item in locationLists"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                    <i class="el-icon-search"></i>
                  </span>
                </div>


                <!-- class="col-sm-4" -->
                <div class="for-border"></div>
                <div class="for-padding-responsive">
                  <el-date-picker
                    v-model="dateFromTo"
                    :picker-options="pickerOptions"
                    type="daterange"
                    format="MM/dd/yyyy"
                    range-separator=""
                    start-placeholder="Select Date(s)"
                    end-placeholder=""
                  />
                  </div>
                <!-- class="col-sm-2" -->
                <div class="for-button">
                  <el-button type="primary" @click="searchLocation" :disabled="(dateFromTo && dateFromTo.length < 1) || !location">Search</el-button
                  >
                </div>
              </div>
            </div>
            <!-- end .search-wrapper -->
          </div>
          <!-- end .col-md-8 -->
        </div>
        <!-- end .row -->
      </div>
      <!-- end .search-container -->
    </div>
    <!-- end .container -->
    <div class="div-img-search-section">
      <img src="../../assets/images/locations-bg.png" alt="" />
    </div>
  </section>
</template>

<script>
import { getLocationsPulldown } from "@/api/location";
import moment from "moment";

export default {
  name: "locationLists",
  data() {
    return {
      loading: false,
      location: "",
      locationOptions: [],
      locationLists: [],
      pickerOptions: {
        disabledDate(date) {
          const dated = moment(new Date()).format("YYYY-MM-DD");
          const comapare = moment(new Date(date)).format("YYYY-MM-DD");
          return new Date(dated) > new Date(comapare);
        },
      },
      dateFrom: moment(new Date()),
      // dateFromTo: [moment(new Date()), moment(new Date())],
      dateFromTo: [],
    };
  },
  mounted() {
    this.getLocations();
  },
  methods: {
    getLocations() {
      this.loading = true;
      getLocationsPulldown().then((response) => {
        if (response.data.success == true) {
          this.locationLists = response.data.data.locations.map((item) => {
            return { value: item.value, label: item.label };
          });
        }
        this.loading = false;
      });
      // this.$forceUpdate()
    },
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.locationOptions = this.locationLists.filter((item) => {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.locationOptions = [];
      }
    },
    handleDateClick(arg) {
      this.dateFrom = moment(new Date(arg)).format("MM/DD/YYYY");
    },
    searchLocation() {
      if (this.location && this.dateFromTo) {
        this.$router.push(
          "/locations/" +
            this.location +
            "?date_from=" +
            moment(new Date(this.dateFromTo[0])).format("YYYY-MM-DD hh:mm:ss") +
            "&date_to=" +
            moment(new Date(this.dateFromTo[1])).format("YYYY-MM-DD hh:mm:ss")
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#locations {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.div-img-search-section {
  height: 60%;
  width: 100%;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.text-xl {

  line-height: 60px;
  @media only screen and (max-width: 1550px) {
    margin:  0 auto;
    width: 930px;
    font-size: 40px !important;
    line-height: 55px;
  }
  @media only screen and (max-width: 1200px) {
    // font-size: 40px !important;
    width: unset;
    line-height: 45px;
  }
  @media only screen and (max-width: 780px) {
    font-size: 30px !important;
  }
  @media only screen and (max-width: 520px) {
    font-size: 6vw !important;
    line-height: 8vw;
  }
}
.container {
  position: relative;
  margin-bottom: -40px;
  // width: 998px !important;
  @media only screen and (max-width: 800px) {
    padding: 0 30px;
    margin-bottom: -120px;
  }
  @media only screen and (max-width: 520px) {
    margin-bottom: -120px;
  }
  @media only screen and (max-width: 380px) {
    margin-bottom: -140px;
  }
}
.wrap-search-Section {
  width: 998px;
  .search-wrapper {
    margin-top: 45px;
    @media only screen and (max-width: 1550px) {
    margin-top: 25px;
  }
    .row {
      border-radius: 6px;
      flex-wrap: unset;
      justify-content: space-around;
      width: 100%;
      align-items: center;
      padding: 0 10px;
      box-shadow: 0 2px 16px 0 rgba(0, 0, 28%, 0.5);
      @media only screen and (max-width: 800px) {
        flex-direction: column;
        padding: 10px 0 0 0;
      }

      div {
        @media only screen and (max-width: 800px) {
          width: 100%;
        }
      }
      .for-padding-responsive{
        @media only screen and (max-width: 800px) {
         padding: 0 15px;
        }
      }
    }
    .for-border {
      border: 1px solid #f2f2f2;
      height: 80px;
      margin: 0 15px;
      @media only screen and (max-width: 800px) {
        height: 0;
        width: 100%;
        margin: 0;
      }
    }
    .for-button {
      @media only screen and (max-width: 800px) {
        width: 100%;
        button {
          width: 100%;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// list.vue?4d246e57